import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Breadcrumb, BreadcrumbItem} from "mdbreact";
import {Link} from "react-router-dom";
import Product from "../../components/product/Product";
import axios from "axios/index";
import {API_URL} from "../../config/Config";
import { ToastContainer, toast } from 'react-toastify';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

import "./../../assets/images/banner-products.jpg";


class Products extends Component {
    constructor(props) {
        super(props);
        this.state = {
            my_city: 'تهران',
            my_city_id: '1',
            ready:false,
            products:[]
        };
    }

    handelChangeCity(event){
        this.setState({
            my_city: event.target.options[event.target.selectedIndex].text,
            my_city_id: event.target.value
        });

    }

    componentDidMount() {
        axios.get(API_URL+'productList/')
            .then(res => {
                if (res.data.status === 1){
                    const products = res.data.data.map(obj => obj);
                    this.setState({ products, ready:true });
                }else{
                    toast.error(res.data.message,{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                }
            });

    }


    render() {

        return (
            <div >
                <div className="jumbotron text-center rtl products-page-header">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5 ">
                        <div className="p-2 text-right rtl">
                            {/*<h1 className="pag-title">محصولات</h1>*/}
                            {/*<p>این یک صفحه خالی است !</p>*/}
                            <select className="browser-default mt-3 p-1 border-dark" onChange={this.handelChangeCity.bind(this)} value={this.state.my_city_id}>
                                <option value="1">تهران</option>
                                <option value="2">اصفهان</option>
                                <option value="3">شیراز</option>
                                <option value="4">مشهد</option>
                                <option value="5">گیلان و مازندران</option>
                                <option value="6">کیش</option>
                                <option value="7">تبریز</option>
                            </select>
                            <br/>
                            <h2 className="mt-4" style={{color:"#32039e"}}>{this.state.my_city}</h2>

                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                <BreadcrumbItem active>محصولات</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            {this.state.products.map(product =>
                                <ReactPlaceholder type='media' rows={7} ready={this.state.ready} key={product.id}>
                                    <Product productObj={product} />
                                </ReactPlaceholder>
                            )}
                        </div>

                    </div>
                </div>
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}

                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(Products);



// WEBPACK FOOTER //
// ./src/containers/products/Products.js